module.exports = __webpack_public_path__ + "static/img/game-SAMURAISHODOWN.5b65f01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/game-SAMURAISHODOWN.jpg
// module id = AMMX
// module chunks = 0